import gql from 'graphql-tag';

/**
 * Data of the read-only block project-time-tracking-summary ("Auswertung Zeiterfassung"): the
 * stored summary per appointment type. Read through `Project.blocks.timeTrackingSummary`, which
 * checks the block's read permission. Also selected by the DC and AC block saves, which change
 * the expected hours.
 */
export const PROJECT_TIME_TRACKING_SUMMARY_FIELDS = gql`
  fragment projectTimeTrackingSummaryFields on ProjectTimeTrackingSummaryBlock {
    id
    number
    timeTrackingSummary {
      items {
        type
        actualSeconds
        expectedSeconds
        deltaSeconds
        entryCount
      }
      totalSeconds
    }
  }
`;
